import React, { useContext } from "react";
import { Autocomplete, FilterBar, SearchBar, Switch } from "@sscs/ui";
import { produce } from "immer";
import { CommonListFilter, LicenseFamilyFilter } from "../../../common";
import { ReportContext } from "../../../context";
import { useLazyGetModelCardsTasksQuery, useLazyGetModelPublishersQuery, } from "../../../services/mlbom.api";
const Filter = ({ filter, onFilterChange }) => {
    var _a, _b, _c;
    const { reportId } = useContext(ReportContext);
    const [getPublishers, { data: publishers, isLoading: publishersAreLoading }] = useLazyGetModelPublishersQuery();
    const [getTasks, { data: tasks, isLoading: tasksAreLoading }] = useLazyGetModelCardsTasksQuery();
    return (React.createElement(FilterBar, { filters: [
            {
                id: "product",
                row: 1,
                control: (React.createElement(SearchBar, { id: "mlbom-product-search", value: (_a = filter.product_or_type) !== null && _a !== void 0 ? _a : "", onChange: (value) => onFilterChange(produce(filter, (draftState) => {
                        draftState.product_or_type = value === "" ? null : value;
                    })), label: "Regex search for model name or model architecture", slotProps: { htmlInput: { maxLength: 256 } }, fullWidth: true })),
            },
            {
                id: "publisher",
                row: 2,
                control: (React.createElement(CommonListFilter, { id: "publisher-filter", value: filter.publisher, filterName: "Publisher", options: publishers, onOpen: () => getPublishers({ ui_id: reportId }), onChange: (_event, value) => onFilterChange(produce(filter, (draftState) => {
                        draftState.publisher = value;
                    })), loading: publishersAreLoading })),
            },
            {
                id: "license",
                row: 2,
                control: (React.createElement(LicenseFamilyFilter, { id: "mlbom-license-family-filter", value: filter.license_family, onChange: (family) => onFilterChange(produce(filter, (draftState) => {
                        draftState.license_family = family;
                    })) })),
            },
            {
                id: "task",
                row: 2,
                control: (React.createElement(Autocomplete, { label: "Filter by task", id: "task-filter", isClearAlwaysVisible: filter.task !== null, value: (_b = filter.task) !== null && _b !== void 0 ? _b : "ALL", onOpen: () => getTasks({ ui_id: reportId }), onChange: (_event, value) => onFilterChange(produce(filter, (draftState) => {
                        draftState.task = value !== "ALL" ? value : null;
                    })), options: ["ALL", ...((_c = tasks === null || tasks === void 0 ? void 0 : tasks.tasks) !== null && _c !== void 0 ? _c : [])], loading: tasksAreLoading, getOptionLabel: (option) => {
                        return option === "ALL" ? "Show all tasks" : option;
                    } })),
            },
            {
                id: "unknown-architecture",
                row: 2,
                fit: true,
                control: (React.createElement(Switch, { title: "Filter models", label: "Unknown architecture", checked: filter.hasUnknownType, onChange: (event) => onFilterChange(produce(filter, (draftFilter) => {
                        draftFilter.hasUnknownType = event.target.checked;
                    })) })),
            },
        ] }));
};
export default Filter;
//# sourceMappingURL=Filter.js.map